/* eslint-disable @typescript-eslint/no-namespace */
export namespace Radii {
  /** Radii Variant Values */
  export type VariantValues = 2 | 4 | 8 | 12 | 16 | 24 | 32 | 48;

  /** Radii Variant Keys */
  export type VariantKeys = 'r2' | 'r4' | 'r8' | 'r12' | 'r16' | 'r24' | 'r32' | 'r48';

  /** Radii Variants */
  export type Variants = {
    [Key in VariantKeys]: number;
  };

  /** Radii Alias Scale Keys */
  export type AliasScaleKeys = number[] & Partial<Record<VariantKeys, number>>;
}

const radii: Radii.AliasScaleKeys = [2, 4, 8, 12, 16, 24, 32, 48];

export const radiiAliases: Radii.Variants = {
  /** @returns `2` */
  r2: radii[0],
  /** @returns `4` */
  r4: radii[1],
  /** @returns `8` */
  r8: radii[2],
  /** @returns `12` */
  r12: radii[3],
  /** @returns `16` */
  r16: radii[4],
  /** @returns `24` */
  r24: radii[5],
  /** @returns `32` */
  r32: radii[6],
  /** @returns `48` */
  r48: radii[7],
};

Object.keys(radiiAliases).map(radius => {
  const radiusKey = radius as Radii.VariantKeys;

  radii[radiusKey] = radiiAliases[radiusKey];
});

export const radiiVariants = Object.keys(radii) as Radii.VariantKeys[];

export default radii;
